import * as React from 'react';
import Button from '@mui/material-next/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from "prop-types";
import { IconButton, FormControlLabel, Checkbox } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import Stack from '@mui/material/Stack';
import BlurryDialog from '../../../widget/BlurryDialog';
import { Formik, Form } from 'formik'

const KanbanConfirmRejectionDialog = (props) => {
  const { t } = useTranslation();

  const descriptionElementRef = React.useRef(null);

  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{skipDialog: props.dontShowAgain}}
      onSubmit={(values) => {
        props.handleReject(props.candidateId, values.skipDialog);
      }}
    >
      {({ handleSubmit, handleChange, values, setFieldValue, errors, isValid, dirty }) => (
        <Form>
          <BlurryDialog
            open={props.open}
            onClose={props.handleClose}
          >
            <DialogTitle
              id="scroll-dialog-title"
              className="color color-medium-red">
              <b>
                {t("rejection")}
              </b>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={props.handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
              <DialogContentText
                id="scroll-dialog-description"
                ref={descriptionElementRef}
                tabIndex={-1}
              >

                <Stack spacing={3}>
                  <div>
                    {t('rejectionEmailWillBeSent') + props.candidateId}
                  </div>
                </Stack>

              </DialogContentText>
            </DialogContent>
            <DialogContent>
              <DialogActions>
              <FormControlLabel
                    value="start"
                    control={
                        <Checkbox
                            checked={values.skipDialog}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                            onChange={() =>
                              setFieldValue(
                                'skipDialog',
                                !values.skipDialog,
                              )
                            }
                        />
                    }
                    label={t('dontShowThisAgain')}
                    labelPlacement="start"
                />
               
                <Button
                  variant="filled"
                  disableElevation
                  className="bg bg-medium-red"
                  type="submit"
                  size="small"
                  style={{ borderRadius: '10px' }}
                  onClick={handleSubmit}
                >
                  {t("confirm")}
                </Button>
              </DialogActions>
            </DialogContent>
          </BlurryDialog>
        </Form>
      )}
    </Formik>
  );
}

KanbanConfirmRejectionDialog.propTypes = {
  candidateId: PropTypes.string,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleReject: PropTypes.func,
  dontShowAgain: PropTypes.bool
};

export default KanbanConfirmRejectionDialog;